import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import axios from '../../../../config/axios';

import DetailData from '../DetailData/DetailData';
import { get_showroom_details } from '../../../../api/API';
const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
}));

// export default function DetailShowroomCard(props) {
//     const { className, ...rest } = props;

//     const classes = useStyles();
//     const [showrooms, setAdmin] = useState();
  
//     useEffect(() => {
//       let mounted = true;
  
//       const fetchAdmin = () => {
//         axios.get('/api/admindetails/1').then(response => {
//             if (mounted) {
//                 setAdmin(response.data.admindetails);
//             }
//         });
//     };
  
//     fetchAdmin();
  
//         return () => {
//             mounted = false;
//         };
//     }, []);
  
//     if (!showrooms) {
//         return null;
//     }

//     return (
//         <Grid
//             {...rest}
//             className={clsx(classes.root, className)}
//             container
//             spacing={3}
//         >
//             <Grid
//                 item
//                 lg={6}
//                 md={6}
//                 xl={4}
//                 xs={12}
//             >
//                 <DetailData showrooms={showrooms} />
//             </Grid>
            
//         </Grid>


//     )
// }

export default class DetailShowroomCard extends React.Component {
    
    constructor(props){
        super(props);
        // console.log( this.props.match );
        console.log('DetailShowroomCard');
        this.state = {
            property: null,
            property_id: props.property_id
        }
    }
  
    async get_data(){
        const postparam = {
            property_id: this.state.property_id
        }; 
        var json = await get_showroom_details(postparam);
        if(json.status){
            console.log(json);
            this.setState({...this.state, property : json.data });
        }
    }
 
    componentDidMount(){
        this.get_data();
    }

    render(){
        return (
            <Grid
                {...this.props}
                className={clsx(this.props.classes.root, this.props.className)}
                container
                spacing={3}
            >
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={4}
                    xs={12}
                >
                { this.state.property ? 
                <DetailData classes={this.props.classes} property={this.state.property} /> : ''
                }
                </Grid>
                
            </Grid>
        )
    }
}



